

export class DanceItem {
    id!:number;
    source!:string;
    name!:string;
    description!:string;
    videoUrl!:string;
    date!:Date;
    startTimeInSeconds:number=0;
    videoUrlForDisplay!:string;
    isUploadedVideo!:boolean;

    public constructor(init?:Partial<DanceItem>) {
        Object.assign(this, init);
    }
}